import { colors } from "@zapalacorp/tokens";
import { GO_SHARE_COMPANY_IDS, GOSSELIN_MOVING_COMPANY_IDS } from "Constants";

export const getCompanyColorAndBackgroundColorById = (
  id: number,
  options: { isVip?: boolean; isPlaceholder?: boolean } = {}
) => {
  // Placeholder tasks have priority over VIP and company colors
  if (options.isPlaceholder) return { color: colors.purple500, backgroundColor: colors.purple50 };

  if (GO_SHARE_COMPANY_IDS.includes(id) || options.isVip)
    return { color: "#F9B02D", backgroundColor: "rgba(249, 176, 45, 0.12);" };

  if (GOSSELIN_MOVING_COMPANY_IDS.includes(id))
    return { color: "#65B65A", backgroundColor: "rgba(101, 182, 90, 0.12);" };

  return { color: colors.brandBlue500, backgroundColor: colors.brandBlue50 };
};
